import { lazy } from "react";

const LoginComponent = lazy(
  () => import("../../../features/authentication/presentation/login")
);
const RegisterComponent = lazy(
  () => import("../../../features/authentication/presentation/register")
);
const SendOtpComponent = lazy(
  () => import("../../../features/authentication/presentation/send-otp")
);
const VerifyOtpComponent = lazy(
  () => import("../../../features/authentication/presentation/verify-otp")
);
const ChangePasswordComponent = lazy(
  () => import("../../../features/authentication/presentation/change-password")
);
const SuccessComponent = lazy(
  () => import("../../../features/authentication/presentation/register/components/SuccessComponent")
);

const AuthRoutes = [
  {
    key: "key.login",
    path: "/",
    component: LoginComponent,
    name: "Login",
  },
  {
    key: "key.register",
    path: "/register",
    component: RegisterComponent,
    name: "Register",
  },
  {
    key: "key.sendOtp",
    path: "/send-otp",
    component: SendOtpComponent,
    name: "Send OTP",
  },
  {
    key: "key.verifyOtp",
    path: "/verify-otp",
    component: VerifyOtpComponent,
    name: "Verify OTP",
  },
  {
    key: "key.changePassword",
    path: "/change-password",
    component: ChangePasswordComponent,
    name: "Change Password",
  },
  {
    key: "key.successScreen",
    path: "/success-screen",
    component: SuccessComponent,
    name: "Success",
  },
];

export default AuthRoutes;
